import React from 'react';
import './VerificationSuccess.css';

function VerificationSuccess({ onFinish }) {
    return (
        <div className="success-container">
            <div className="success-card">
                <div className="success-logo">
                    Verifilite
                </div>

                <div className="success-content">
                    <div className="success-icon-wrapper">
                        <svg className="success-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <circle 
                                cx="50" 
                                cy="50" 
                                r="35" 
                                fill="none" 
                                stroke="#10b981" 
                                strokeWidth="3" 
                                strokeDasharray="8 6"
                                strokeLinecap="round"
                            />
                            <path 
                                d="M 35 50 L 45 60 L 65 40" 
                                stroke="#10b981" 
                                strokeWidth="5" 
                                strokeLinecap="round" 
                                strokeLinejoin="round"
                                fill="none"
                            />
                        </svg>
                    </div>

                    <h2 className="success-title">Kyc Submited</h2>
                    <p className="success-subtitle">That's all, no further action needed.</p>
                </div>

                {/* <button className="finish-btn">
                    Finish now
                </button> */}

                 <div className="capture-footer">Secured by VerifiLite</div>
            </div>
        </div>
    );
}

export default VerificationSuccess;

